export const ADD_MUTATE = require('./add');
export const DELETE_BRANCH_MUTATE = require('./deleteBranch');
export const BRANCH_MUTATE = require('./createBranch');
export const COMMIT_ALL_MUTATE = require('./commitAll');
export const COMMIT_MUTATE = require('./commit');
export const CLEAN_MUTATE = require('./clean');
export const CLONE_MUTATE = require('./clone');
export const OPEN_MUTATE = require('./open');
export const STASH_MUTATE = require('./stash');
export const SYNC_MUTATE = require('./sync');
export const PUSH_MUTATE = require('./push');
export const PULL_MUTATE = require('./pull');
export const TAG_MUTATE = require('./tag');
export const UNSTASH_MUTATE = require('./unstash');
export const UNSTAGE_MUTATE = require('./unstage');
export const CHECKOUT_MUTATE = require('./checkout');
export const CLOSE_MUTATE = require('./close');
export const MERGE_MUTATE = require('./merge');
export const UNDO_LAST_COMMIT_MUTATE = require('./undoLastCommit');

export const SET_GLOBAL_DATA = require('./setGlobalData');

export const CHANGE_REPO = require('./changeRepo');
